import { render } from "./LetterboxModal.vue?vue&type=template&id=208447b7"
import script from "./LetterboxModal.vue?vue&type=script&lang=js"
export * from "./LetterboxModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__